import { render, staticRenderFns } from "./PriceInput.vue?vue&type=template&id=6287cb90"
import script from "./PriceInput.vue?vue&type=script&lang=ts"
export * from "./PriceInput.vue?vue&type=script&lang=ts"
import style0 from "./PriceInput.vue?vue&type=style&index=0&id=6287cb90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports